import Vue from "vue";
import Vuex from "vuex";
import router from "../router";
import md5 from "js-md5";
Vue.use(Vuex);
var root = process.env.API_ROOT;
const state = {
  id_example: "", //商城ID
  user_id: "null", //用户ID
  name: "", //积分名称
  userinfo: "", //用户信息
  webInfo: {},
  cartnum: 0, //购物车数量
  notice: "", //维护公告
  classesdatas: "", //商品列表分类
  address: {
    xq: "北京朝阳区三环以内",
    area: ["北京", "朝阳区", "三环以内"],
    id: [1, 72, 2799],
    ti: 0
  }, //地址缓存
  mallStockShow: false, // 库存显示开关
};
const mutations = {
  setAddress(state, value) {
    var xq = "";
    value.area.forEach(item => {
      xq = xq + item;
    });
    state.address.xq = xq;
    state.address.area = value.area;
    state.address.id = value.id;
    localStorage.setItem("messageStore1", JSON.stringify(state));
  },
  webInfo(state) {
    var str = window.location.host;
    var ts = Date.parse(new Date());
    ts = ts / 1000;
    var apiKey = "1106e4d408248208";
    var securityKey = "D5695EBCCF795D68";
    var sign = md5(
      md5("apiKey=" + apiKey + "securityKey=" + securityKey + "timeStamp=" + ts)
    );
    var malltype = str.split(".")[0];
    // var url=root + '/sys/info/domain/'+malltype;
    var url = root + "/sys/info/";
    $.ajax({
      type: "GET",
      // url:root+'/sys/info',//本地
      url: url, //正式地址
      data: {
        apiKey: apiKey,
        sign: sign,
        timeStamp: ts,
        terminal: "pc",
        domain: malltype,
        prdfix: malltype
      },
      success: function(res) {
        const id_example = JSON.parse(localStorage.getItem("id_example"));
        if (id_example) {
          state.id_example = id_example;
        }

        if (res.code == 100) {
          if (state.id_example == "" || id_example != res.data.id_example) {
            state.id_example = res.data.id_example;
            localStorage.setItem("messageStore1", JSON.stringify(state));
            localStorage.setItem(
              "id_example",
              JSON.stringify(res.data.id_example)
            );
            // window.history.go(0);
          }
          state.id_example = res.data.id_example;
          localStorage.setItem("login_code", res.data.wx_app_id)
          state.webInfo = res.data;
          state.mallStockShow = res.data.stock_status;
          setTimeout(() => {
            res.data.switch_status == 0 ? router.push({ name: "Over" }) : "";
          }, 200);
          if (state.user_id == "null") {
            res.data.visitor_status == 0 ? router.push({ name: "Login" }) : "";
          }
          document.title = res.data.name; //商城名称
          var link = document.createElement("link");
          link.type = "text/css";
          link.rel = "stylesheet";
          // link.href = 'http://fenimge.li91.net/Uploads/Static/css/style'+res.data.id_example+'_pc.css';//测试服
          link.href =
            "https://shopapi.fensaas.com/static/css/style" +
            res.data.id_example +
            "_pc.css"; //正式服
          var head = document.getElementsByTagName("head")[0];
          head.appendChild(link);
          var link =
            document.querySelector("link[rel*='icon']") ||
            document.createElement("link"); //商城icon
          link.type = "image/x-icon";
          link.rel = "shortcut icon";
          if (res.data.logo_icon == "" || res.data.logo_icon == null) {
            link.href = "/static/favicon.ico"; //默认图标
          } else {
            link.href = res.data.logo_icon; //商城icon
          }
          document.getElementsByTagName("head")[0].appendChild(link); //设置ico
          localStorage.setItem("messageStore1", JSON.stringify(state));
        }
      },
      error: function(err) {
        console.log("请求失败");
        console.log(err);
      }
    });
  },
  userInfo(state) {
    var ts = new Date($.ajax({ url: "/", type: "OPTIONS", async: false }).getResponseHeader("Date"));
    // var ts = Date.parse(new Date());
    ts = ts.getTime() / 1000;
    console.log("ts13", ts);
    var apiKey = "1106e4d408248208";
    var securityKey = "D5695EBCCF795D68";
    var sign = md5(
      md5("apiKey=" + apiKey + "securityKey=" + securityKey + "timeStamp=" + ts)
    );
    if (state.user_id == "") {
      state.user_id = "null";
    }
    $.ajax({
      type: "POST",
      url: root + "/user/user/info", //正式地址
      data: {
        apiKey: apiKey,
        sign: sign,
        timeStamp: ts,
        id_example: state.id_example,
        token_user: state.user_id
      },
      success: function(res) {
        console.log("res23232", res);
        if (res.code == 100) {
          state.userinfo = res.data;
          localStorage.setItem("messageStore1", JSON.stringify(state));
        } else {
          state.userinfo = "";
          state.user_id = "null";
        }
      },
      error: function(err) {
        // console.log('请求失败')
        // console.log(err)
      }
    });
  },
  cartnum(state) {
    var str = window.location.host;
    var ts = Date.parse(new Date());
    ts = ts / 1000;
    var apiKey = "1106e4d408248208";
    var securityKey = "D5695EBCCF795D68";
    var sign = md5(
      md5("apiKey=" + apiKey + "securityKey=" + securityKey + "timeStamp=" + ts)
    );
    var malltype = str.split(".")[0];
    $.ajax({
      type: "POST",
      url: root + "/user/cart/count", //正式地址
      data: {
        apiKey: apiKey,
        sign: sign,
        timeStamp: ts,
        id_example: state.id_example,
        token_user: state.user_id
      },
      success: function(res) {
        if (res.code == 100) {
          state.cartnum = res.data;
        } else {
          state.cartnum = 0;
        }
      },
      error: function(err) {
        console.log("请求失败");
        console.log(err);
      }
    });
  },
  tonggao(state) {
    var ts = Date.parse(new Date());
    ts = ts / 1000;
    var apiKey = "1106e4d408248208";
    var securityKey = "D5695EBCCF795D68";
    var sign = md5(
      md5("apiKey=" + apiKey + "securityKey=" + securityKey + "timeStamp=" + ts)
    );
    $.ajax({
      type: "POST",
      url: root + "/sys/maintain", //正式地址
      data: {
        apiKey: apiKey,
        sign: sign,
        timeStamp: ts,
        id_example: state.id_example
      },
      success: function(res) {
        if (res.code == 100) {
          state.notice = res.data.data;
          if (res.data.status == 1) {
            //商城维护
            setTimeout(() => {
              router.push({ name: "Over" });
            }, 200);
          } else {
          }
        }
      }
    });
  },
  classesdatas(state) {
    var ts = Date.parse(new Date());
    ts = ts / 1000;
    var apiKey = "1106e4d408248208";
    var securityKey = "D5695EBCCF795D68";
    var sign = md5(
      md5("apiKey=" + apiKey + "securityKey=" + securityKey + "timeStamp=" + ts)
    );
    $.ajax({
      type: "POST",
      url: root + "/sys/typelist", //正式地址
      data: {
        apiKey: apiKey,
        sign: sign,
        timeStamp: ts,
        id_example: state.id_example,
        terminal: "pc"
      },
      success: function(res) {
        if (res.code == 100) {
          state.classesdatas = res.data;
          console.log(state.classesdatas);
        }
      }
    });
  },
};
export default new Vuex.Store({
  state,
  mutations
});



// WEBPACK FOOTER //
// ./src/vuex/store.js